import styled from "styled-components";
import { colors, screenSizes, typography } from "@streeteasy/design-system";
import { iconSizes } from "@streeteasy/design-system/icon";
import CheckIcon from "@streeteasy/design-system/icon/brand/CheckIcon";
import DownsideIcon from "@streeteasy/design-system/icon/brand/DownsideIcon";

export const Wrapper = styled.div`
  @media screen and (max-width: ${screenSizes.LARGE_SCREEN}px) {
    padding: 0 10px;
    position: relative;
  }
`;

export const SeeScheduleSection = styled.div`
  text-align: center;
`;

export const SeeScheduleCaption = styled(typography.Caption)`
  color: ${colors.TEXT_SECONDARY};
  margin: 32px 0 8px;
`;

const iconStylesFor = dsIcon =>
  styled(dsIcon).attrs({ size: iconSizes.SM })`
    margin-top: 126px;
  `;

export const FeedbackPassedIcon = iconStylesFor(DownsideIcon);

export const FeedbackPassedTitle = styled(typography.PrimaryLarge)`
  color: ${colors.TEXT_SECONDARY};
  margin: 16px 0 24px;
`;

export const FeedbackCaption = styled(typography.SecondaryMedium)`
  margin: 8px 0 24px;
`;

export const FeedbackRecordedIcon = iconStylesFor(CheckIcon);

export const FeedbackRecordedTitle = styled(typography.PrimaryMedium)`
  margin: 16px 0 0;
`;

export const FeedbackRecordedCTACaption = styled(typography.SecondarySmall)`
  margin-bottom: 16px;
`;
